import { lazy } from 'react'
import { MessageSquare } from 'lucide-react'
import type { FeatureRoute, NavItem } from '@/features/types'

const Ai = lazy(() => import('@/features/ai/pages/Ai').then((m) => ({ default: m.Ai })))

export const aiRoutes: FeatureRoute[] = [
  { path: 'ai', element: <Ai /> },
]

export const aiNav: NavItem[] = [
  { to: '/ai', label: 'AI assistant', icon: MessageSquare, section: 'Tools' },
]
